var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 15.6289L17.1016 14.3828L18.7344 16.0156L17.4453 17.3047L15.8125 15.6289ZM18.3477 8.625H21.0977V10.4727H18.3477V8.625ZM13.75 4.80078C14.5807 5.28776 15.2396 5.94661 15.7266 6.77734C16.2422 7.60807 16.5 8.52474 16.5 9.52734C16.5 11.0456 15.9557 12.349 14.8672 13.4375C13.8073 14.4974 12.5182 15.0273 11 15.0273C9.48177 15.0273 8.17839 14.4974 7.08984 13.4375C6.02995 12.349 5.5 11.0456 5.5 9.52734C5.5 8.52474 5.74349 7.60807 6.23047 6.77734C6.74609 5.94661 7.41927 5.28776 8.25 4.80078V0.375H13.75V4.80078ZM3.65234 8.625V10.4727H0.902344V8.625H3.65234ZM10.0977 19.582V16.875H11.9023V19.582H10.0977ZM3.26562 16.0156L4.89844 14.3398L6.1875 15.6289L4.55469 17.3047L3.26562 16.0156Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEeIcon);
export default __webpack_public_path__ + "static/media/EEIcon.eadc57d05a77c40be847c932314cabf7.svg";
export { ForwardRef as ReactComponent };